import React, { useEffect, useState } from "react";
import BibleStudyItems from "./BibleStudyItems";
import { makeGetRequest } from "../../../utils/api";
import { urls } from "../../../utils/urls";
import NoResourceMessage from "../resources/NoResourceMessage";

function BibleStudyList(props) {
  const [dataPulled, setDataPulled] = useState(false);
  const handleBibleStudyData = async () => {
    const response = await makeGetRequest(
      urls.resources + "?active=True",
      "",
      true
    );
    const bibleStudyData = response.data.filter((item) => {
      return item.type === 21;
    });
    setBibleStudyItemsList(bibleStudyData);
    setDataPulled(true)
  };

  useEffect(() => {
    handleBibleStudyData();
  }, []);

  const [bibleStudyItemsList, setBibleStudyItemsList] = useState([]);

  return (
    <>
      {dataPulled && bibleStudyItemsList.length === 0 ? (
        <NoResourceMessage resource={"bible study"} />
      ) : null}
      <BibleStudyItems
        bibleStudyItemsList={bibleStudyItemsList}
        setFile={props.setFile}
        setXframe={props.setXframe}
      />
    </>
  );
}

export default BibleStudyList;
